// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"163":"824741a5","410":"21a7ee47","440":"3af3dbbd","600":"bb2adbb6","919":"037cf9d6"}[chunkId] + ".chunk.css";
};